import { Loader2, Check, Trash2, ToggleRight, ToggleLeft } from "lucide-react";

/**
 * One row of the Service Menu admin grid: name + id + price + duration + actions.
 */
export default function ServiceRow({ service, draft, busy, onDraft, onSave, onToggle, onRemove }) {
    const dirty =
        draft.price !== service.price.toString() ||
        parseInt(draft.duration_min, 10) !== service.duration_min ||
        draft.name !== service.name;

    return (
        <div
            data-testid={`row-${service.service_id}`}
            className={`p-4 grid grid-cols-12 gap-3 items-center text-sm border-t border-white/5 first:border-0 ${
                !service.active ? "opacity-50" : ""
            }`}
        >
            <input
                value={draft.name || ""}
                onChange={(e) => onDraft(service.service_id, "name", e.target.value)}
                className="col-span-12 sm:col-span-5 bg-ink/40 border border-transparent hover:border-white/15 focus:border-gold/50 rounded-lg px-3 py-2 outline-none"
            />
            <p
                className="hidden sm:block col-span-2 text-xs text-white/40 truncate font-mono"
                title={service.service_id}
            >
                {service.service_id}
            </p>
            <div className="col-span-6 sm:col-span-2 flex items-center gap-1">
                <span className="text-gold">$</span>
                <input
                    type="number" step="1" min="0"
                    value={draft.price}
                    onChange={(e) => onDraft(service.service_id, "price", e.target.value)}
                    data-testid={`price-${service.service_id}`}
                    className="w-full bg-ink/40 border border-transparent hover:border-white/15 focus:border-gold/50 rounded-lg px-2 py-2 outline-none"
                />
            </div>
            <div className="col-span-6 sm:col-span-1 flex items-center gap-1">
                <input
                    type="number" min="0"
                    value={draft.duration_min}
                    onChange={(e) => onDraft(service.service_id, "duration_min", e.target.value)}
                    className="w-full bg-ink/40 border border-transparent hover:border-white/15 focus:border-gold/50 rounded-lg px-2 py-2 outline-none"
                />
                <span className="text-white/40 text-xs">m</span>
            </div>
            <div className="col-span-12 sm:col-span-2 flex items-center justify-end gap-2">
                <button
                    type="button"
                    title={service.active ? "Hide from menu" : "Restore to menu"}
                    onClick={() => onToggle(service)}
                    disabled={busy}
                    className="p-2 text-white/55 hover:text-gold transition disabled:opacity-50"
                >
                    {service.active ? <ToggleRight className="w-5 h-5" /> : <ToggleLeft className="w-5 h-5" />}
                </button>
                <button
                    type="button"
                    title="Soft-delete"
                    onClick={() => onRemove(service)}
                    disabled={busy}
                    className="p-2 text-white/55 hover:text-rose transition disabled:opacity-50"
                >
                    <Trash2 className="w-4 h-4" />
                </button>
                <button
                    type="button"
                    onClick={() => onSave(service.service_id)}
                    disabled={!dirty || busy}
                    data-testid={`save-${service.service_id}`}
                    className={`px-3 py-1.5 rounded-full text-xs font-medium transition flex items-center gap-1 ${
                        dirty ? "bg-gold text-ink hover:opacity-90" : "bg-white/5 text-white/30 cursor-not-allowed"
                    }`}
                >
                    {busy ? <Loader2 className="w-3 h-3 animate-spin" /> : <Check className="w-3 h-3" />}
                    Save
                </button>
            </div>
        </div>
    );
}
